export default async function getAction(name: string) {
  try {
    const func = (await import(
      /* webpackChunkName: "actions-[request]" */ `./${name}.ts`
    ).catch((error) => console.error(error))) as {
      default: (...args: unknown[]) => void;
    };

    return func.default;
  } catch (e) {
    console.error('Error while handling onClose');
    console.error(e);
    return undefined;
  }
}
